export function isIOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

// True when running inside Mobile Safari proper on iOS — not Chrome/Firefox/
// Edge on iOS (which are all WebKit but expose different UA strings and have
// no Share → "Add to Home Screen" entry point), and not inside a third-party
// in-app browser (Instagram, Facebook, etc., which use WKWebView and also
// can't add to the home screen). We use this to decide whether it makes
// sense to surface the iOS install hint at all — telling an Instagram-webview
// user to "tap Share → Add to Home Screen" would just confuse them.
export function isIOSSafari(): boolean {
    if (!isIOS()) {
        return false;
    }

    const ua = navigator.userAgent;

    // Other iOS browsers re-use WebKit but still advertise themselves.
    const isOtherIOSBrowser = /CriOS|FxiOS|EdgiOS|OPiOS|GSA|YaBrowser|DuckDuckGo/i.test(ua);
    if (isOtherIOSBrowser) {
        return false;
    }

    // Common in-app browser markers. Not exhaustive — Apple gives third-party
    // apps no reliable UA — but covers the apps users come from in practice.
    const isInAppBrowser = /FBAN|FBAV|FB_IAB|Instagram|Line|MicroMessenger|WhatsApp|Snapchat|LinkedInApp|TikTok|Discord/i.test(ua);
    if (isInAppBrowser) {
        return false;
    }

    // Safari proper advertises "Safari/<version>". WKWebViews without an
    // app-specific token also include this, so it's a necessary but not
    // sufficient check — the negative filters above carry most of the weight.
    return ua.includes('Safari');
}

// True when the app is running as an installed PWA. The standalone media
// query is the modern signal (Chromium, Safari 16.4+); `navigator.standalone`
// is the legacy WebKit flag still set on older iOS versions. We need both
// because iOS Safari only allows Web Push subscriptions inside an installed
// PWA — non-PWA visitors must "Add to Home Screen" first.
export function isInstalledPwa(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }

    const standaloneMedia = window.matchMedia?.('(display-mode: standalone)').matches === true;
    const iosLegacy = (navigator as Navigator & { standalone?: boolean }).standalone === true;
    return standaloneMedia || iosLegacy;
}
